module.exports = __webpack_public_path__ + "static/media/PnT_Logo.bfdb79df.png";